import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    deviceItems: null
  },
  mutations: {
    SET_DEVICE(state, items) {
      state.deviceItems = items
    }
  },
  actions: {}
}) 

export default store
